import { useTranslation } from 'react-i18next';

function splitParagraphs(text: string): string[] {
  return text.split(/(?:\r?\n){2,}/);
}

export default function Fitness() {
  const { t } = useTranslation();

  const suited = ['butlerJob.fit.suited.0', 'butlerJob.fit.suited.1', 'butlerJob.fit.suited.2', 'butlerJob.fit.suited.3'];
  const challenge = ['butlerJob.fit.challenge.0', 'butlerJob.fit.challenge.1', 'butlerJob.fit.challenge.2'];

  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[1100px] mx-auto px-8 md:px-12">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('butlerJob.fit.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('butlerJob.fit.title')}
          </h2>
          <p className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">
            {t('butlerJob.fit.titleEn')}
          </p>
          <div className="gold-line mx-auto mb-6"></div>
          {splitParagraphs(String(t('butlerJob.fit.lead'))).map((paragraph, index) => (
            <p key={index} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">
              {paragraph}
            </p>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <div className="bg-background-50 border border-accent-500/25 p-6 md:p-8">
            <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-5 pb-4 border-b border-background-200/60">
              {t('butlerJob.fit.suitedTitle')}
            </h3>
            <ul className="space-y-4">
              {suited.map((key, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <i className="ri-check-line text-accent-500 text-[17px] mt-0.5 flex-shrink-0"></i>
                  <span className="text-[16px] text-foreground-600 tracking-[0.04em] leading-[1.8]">{t(key)}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-background-50 border border-background-200/60 p-6 md:p-8">
            <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-5 pb-4 border-b border-background-200/60">
              {t('butlerJob.fit.challengeTitle')}
            </h3>
            <ul className="space-y-4">
              {challenge.map((key, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <i className="ri-subtract-line text-foreground-400 text-[17px] mt-0.5 flex-shrink-0"></i>
                  <span className="text-[16px] text-foreground-600 tracking-[0.04em] leading-[1.8]">{t(key)}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {splitParagraphs(String(t('butlerJob.fit.note'))).map((paragraph, index) => (
          <p key={index} className="text-[15px] text-foreground-500 tracking-[0.04em] leading-[1.9] mt-8">
            {paragraph}
          </p>
        ))}
      </div>
    </section>
  );
}
